class NodusPopupImage extends HTMLElement {
  connectedCallback() {
    this.storageKey = `nodusPopupImageClosed-${this.id}`;
    if (window.sessionStorage.getItem(this.storageKey)) return;

    const delay = parseInt(this.dataset.delay || "5", 10) * 1000;
    this.timeoutId = window.setTimeout(() => this.show(), delay);

    this.closeButton = this.querySelector(".nodus-popup-image__close");
    this.closeButton?.addEventListener("click", () => this.hide());

    this.boundBackdropClick = (event) => {
      if (event.target === this) this.hide();
    };
    this.addEventListener("click", this.boundBackdropClick);

    this.boundKeyup = (e) => {
      if (e.code === "Escape") this.hide();
    };
    this.addEventListener("keyup", this.boundKeyup);
  }

  disconnectedCallback() {
    window.clearTimeout(this.timeoutId);
    this.removeEventListener("click", this.boundBackdropClick);
    this.removeEventListener("keyup", this.boundKeyup);
  }

  show() {
    this.style.display = "";
    this.setAttribute("open", "");
    document.body.classList.add("overflow-hidden");
    trapFocus(this, this.closeButton || this);
  }

  hide() {
    this.removeAttribute("open");
    this.style.display = "none";
    document.body.classList.remove("overflow-hidden");
    removeTrapFocus();
    window.sessionStorage.setItem(this.storageKey, "1");
  }
}

if (!window.customElements.get("nodus-popup-image")) {
  window.customElements.define("nodus-popup-image", NodusPopupImage);
}
